import { TOrder } from "@core/types";

export function calculateTotalAppliedCouponsAndRewardPoints(order: TOrder): number {
    const orderTotal = order.total ?? 0;
    return (orderTotal -
        (order?.rewardPoints ?? 0) -
        (Array.isArray(order?.coupons) ? order!.coupons.reduce((acc, coupon) => acc - (coupon.discountAmount ?? 0), 0) : 0));
}